
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2.0833333333333335,0,0,2.0833333333333335,0,0)"}},[_c('defs',[_c('style',[_v('.a{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}')])]),_c('title',[_v('keyboard-delete')]),_c('line',{staticClass:"a",attrs:{"x1":"16.5","y1":"9.747","x2":"12","y2":"14.247"}}),_c('line',{staticClass:"a",attrs:{"x1":"12","y1":"9.747","x2":"16.5","y2":"14.247"}}),_c('path',{staticClass:"a",attrs:{"fill":"none","d":"M11.121,6H18a1.5,1.5,0,0,1,1.5,1.5v9A1.5,1.5,0,0,1,18,18H11.121a1.5,1.5,0,0,1-1.06-.439L4.72,12.527a.749.749,0,0,1,0-1.06l5.341-5.031A1.5,1.5,0,0,1,11.121,6Z"}})])])
          )
        }
      }
    